import { render, staticRenderFns } from "./NuevoCierre.vue?vue&type=template&id=5ec62584"
import script from "./NuevoCierre.vue?vue&type=script&lang=js"
export * from "./NuevoCierre.vue?vue&type=script&lang=js"
import style0 from "./NuevoCierre.vue?vue&type=style&index=0&id=5ec62584&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports